__turbopack_context__.v({
  "content": "loader-module__X4GsdG__content",
  "counterRotate": "loader-module__X4GsdG__counterRotate",
  "marker": "loader-module__X4GsdG__marker",
  "orbit": "loader-module__X4GsdG__orbit",
  "overlay": "loader-module__X4GsdG__overlay",
  "rotate": "loader-module__X4GsdG__rotate",
  "subtitle": "loader-module__X4GsdG__subtitle",
  "title": "loader-module__X4GsdG__title",
});
